module.exports = __webpack_public_path__ + "eg.2e7de6a77387ff51ff6a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/eg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/eg.svg
// module chunks = styles